module.exports = __webpack_public_path__ + "static/story_photo_02-eeffcdc3b340278c0db8664e45be45c9.jpg";